import { WarningIcon } from "../SvgIcons"
import styles from "./WarningBlock.module.scss"

const WarningBlock = ({ message }: { message: string }) => {
  return (
    <div className={styles["warning-container"]}>
      <WarningIcon />
      <p>{message}</p>
    </div>
  )
}

export default WarningBlock
